const hasManualHeroBlock = (blocks) =>
  (Array.isArray(blocks) ? blocks : []).some((block) => {
    const component = block?.component;

    if (component?.name === 'HeroSection' && component?.options?.useDynamicData === false) {
      return true;
    }

    return hasManualHeroBlock(block?.children);
  });

/**
 * A HeroSection with dynamic data explicitly disabled is authored campaign
 * content, not a placeholder for the runtime editorial hero. Treat that
 * Builder setting as the rendering contract so published and preview pages
 * cannot disagree about which headline/media should be shown.
 */
export const hasManualBuilderHero = (content) => hasManualHeroBlock(content?.data?.blocks);
